import { Fragment } from "react"
import { MetaTags } from "react-meta-tags"

const recursos = [
  {
    tipo: "Video",
    titulo: "Técnicas de impermeabilización en terrazas",
    meta: "18 min · Nivel básico",
    acceso: "Libre",
    accesoLibre: true,
    thumbColor: "#fde2e4",
  },
  {
    tipo: "PDF",
    titulo: "Guía de aplicación Fester 5000",
    meta: "12 págs · Ficha técnica",
    acceso: "Libre",
    accesoLibre: true,
    thumbColor: "#dbe7fb",
  },
  {
    tipo: "Webinar",
    titulo: "Novedades de producto 2026",
    meta: "45 min · Grabación",
    acceso: "Libre",
    accesoLibre: true,
    thumbColor: "#fdf0cf",
  },
  {
    tipo: "Curso",
    titulo: "Certificación instalador Fester nivel 2",
    meta: "6 módulos · Con examen",
    acceso: "Requiere login",
    accesoLibre: false,
    thumbColor: "#d8eede",
    overlay: "Curso",
  },
]

const styles = {
  page: {
    backgroundColor: "#f4f5f7",
    minHeight: "100vh",
    fontFamily: "'Segoe UI', Helvetica, Arial, sans-serif",
    color: "#1c2733",
  },
  header: {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e7e9ed",
    padding: "16px 32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  brand: { display: "flex", alignItems: "center", gap: "12px" },
  logo: {
    border: "1px solid #1c2733",
    borderRadius: "4px",
    padding: "4px 8px",
    fontWeight: 700,
    fontSize: "14px",
    letterSpacing: "1px",
  },
  brandName: { fontWeight: 600, fontSize: "15px", lineHeight: 1.1 },
  brandSub: { fontSize: "12px", color: "#8a93a2" },
  nav: { display: "flex", alignItems: "center", gap: "28px" },
  navLink: {
    color: "#42505f",
    fontSize: "14px",
    textDecoration: "none",
    cursor: "pointer",
  },
  loginBtn: {
    backgroundColor: "#e8362b",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "9px 18px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },
  hero: {
    background: "linear-gradient(180deg, #1b3a66 0%, #16335a 100%)",
    color: "#ffffff",
    textAlign: "center",
    padding: "72px 24px 64px",
  },
  heroTag: {
    fontSize: "12px",
    letterSpacing: "2px",
    color: "#9fc0e8",
    marginBottom: "12px",
  },
  heroTitle: {
    fontSize: "30px",
    fontWeight: 700,
    color: "#ffffff",
    margin: 0,
    padding: "8px 0 16px",
  },
  heroSub: { fontSize: "15px", color: "#cdd9e9", margin: "0 0 28px" },
  searchWrap: {
    display: "flex",
    maxWidth: "620px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    padding: "8px",
    gap: "8px",
  },
  searchInput: {
    flex: 1,
    border: "none",
    outline: "none",
    fontSize: "15px",
    padding: "8px 12px",
    color: "#1c2733",
    backgroundColor: "transparent",
  },
  searchBtn: {
    backgroundColor: "#1b3a66",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 22px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },
  section: { maxWidth: "1040px", margin: "0 auto", padding: "32px 24px 8px" },
  sectionTitle: {
    fontSize: "13px",
    letterSpacing: "1px",
    color: "#6b7480",
    fontWeight: 600,
    marginBottom: "20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "20px",
  },
  card: {
    backgroundColor: "#ffffff",
    border: "1px solid #e7e9ed",
    borderRadius: "10px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  thumb: {
    height: "120px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  thumbIcon: {
    width: "28px",
    height: "28px",
    border: "2px solid #9aa4b2",
    borderRadius: "4px",
  },
  overlayBadge: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    backgroundColor: "rgba(0,0,0,0.55)",
    color: "#ffffff",
    fontSize: "11px",
    padding: "3px 8px",
    borderRadius: "4px",
  },
  cardBody: {
    padding: "14px 16px 16px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  typeBadge: {
    alignSelf: "flex-start",
    border: "1px solid #d6dae0",
    borderRadius: "12px",
    fontSize: "11px",
    color: "#5b6470",
    padding: "2px 10px",
  },
  cardTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#1c2733",
    margin: 0,
    lineHeight: 1.3,
  },
  cardMeta: { fontSize: "13px", color: "#8a93a2", margin: 0 },
  accessRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "4px",
    paddingTop: "10px",
    borderTop: "1px solid #f0f1f4",
  },
  accessFree: {
    backgroundColor: "#e3f3e8",
    color: "#2e7d4f",
    fontSize: "12px",
    padding: "3px 10px",
    borderRadius: "4px",
  },
  accessLocked: {
    backgroundColor: "#f1f2f4",
    color: "#6b7480",
    fontSize: "12px",
    padding: "3px 10px",
    borderRadius: "4px",
  },
  ctaBox: {
    maxWidth: "1040px",
    margin: "24px auto 0",
    backgroundColor: "#ffffff",
    border: "1px solid #e7e9ed",
    borderRadius: "10px",
    padding: "20px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "20px",
  },
  ctaTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#1c2733",
    margin: "0 0 4px",
  },
  ctaText: { fontSize: "13px", color: "#8a93a2", margin: 0 },
  ctaBtn: {
    border: "1px solid #c9ced6",
    backgroundColor: "#ffffff",
    borderRadius: "6px",
    padding: "9px 16px",
    fontSize: "14px",
    fontWeight: 600,
    color: "#1c2733",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  footer: {
    textAlign: "center",
    fontSize: "12px",
    color: "#9aa4b2",
    padding: "32px 24px 40px",
  },
}

const Editoriales = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>Centro de recursos | La Academia Fester</title>
      </MetaTags>

      <div style={styles.page}>
        <header style={styles.header}>
          <div style={styles.brand}>
            <span style={styles.logo}>LAF</span>
            <div>
              <div style={styles.brandName}>La Academia Fester</div>
              <div style={styles.brandSub}>Centro de recursos</div>
            </div>
          </div>
          <nav style={styles.nav}>
            <a style={styles.navLink}>Inicio</a>
            <a style={styles.navLink}>Recursos</a>
            <a style={styles.navLink}>Acerca de</a>
            <button style={styles.loginBtn}>Iniciar sesión →</button>
          </nav>
        </header>

        <section style={styles.hero}>
          <div style={styles.heroTag}>ACCESO LIBRE · SIN REGISTRO</div>
          <h1 style={styles.heroTitle}>Centro de recursos de capacitación</h1>
          <p style={styles.heroSub}>
            Videos, guías y materiales para instaladores y distribuidores Fester
          </p>
          <div style={styles.searchWrap}>
            <input
              style={styles.searchInput}
              type="text"
              placeholder="Buscar materiales, temas, productos..."
            />
            <button style={styles.searchBtn}>Buscar</button>
          </div>
        </section>

        <section style={styles.section}>
          <div style={styles.sectionTitle}>RECURSOS DESTACADOS</div>
          <div style={styles.grid}>
            {recursos.map((recurso, index) => (
              <div style={styles.card} key={index}>
                <div
                  style={{
                    ...styles.thumb,
                    backgroundColor: recurso.thumbColor,
                  }}
                >
                  <span style={styles.thumbIcon} />
                  {recurso.overlay && (
                    <span style={styles.overlayBadge}>{recurso.overlay}</span>
                  )}
                </div>
                <div style={styles.cardBody}>
                  <span style={styles.typeBadge}>{recurso.tipo}</span>
                  <h3 style={styles.cardTitle}>{recurso.titulo}</h3>
                  <p style={styles.cardMeta}>{recurso.meta}</p>
                  <div style={styles.accessRow}>
                    <span
                      style={
                        recurso.accesoLibre
                          ? styles.accessFree
                          : styles.accessLocked
                      }
                    >
                      {recurso.acceso}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <div style={styles.ctaBox}>
          <div>
            <p style={styles.ctaTitle}>
              ¿Eres instalador certificado o distribuidor?
            </p>
            <p style={styles.ctaText}>
              Inicia sesión para acceder a cursos con certificación, exámenes y
              seguimiento de progreso.
            </p>
          </div>
          <button style={styles.ctaBtn}>Iniciar sesión ↗</button>
        </div>

        <footer style={styles.footer}>
          © 2026 Henkel Capital | Términos y Condiciones | Políticas de
          privacidad | By Faraday Services
        </footer>
      </div>
    </Fragment>
  )
}

export default Editoriales
